export default {
  activeTimeslots(state) {
    return state.timeslots.filter(x => x.active);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/timeslots/getters.js